import { useMemo, useState } from "react";
import { filterObjectByKeys } from "./DreamSearchFilter";
import debounce from "lodash/debounce";
import { useDreamSearchContext } from "../../../DreamSearchContext";
import { EnumSingleSelectChipFilter } from "@portal/app/manage/_components/DreamTable";
import { FilterComponentProps } from "./DreamSearchFilter";

export const ProgramDurationDaysFilterComponent = ({
  value,
  setValue,
}: FilterComponentProps<number>) => {
  const { filterSettings } = useDreamSearchContext();
  const [localValue, setLocalValue] = useState<number | null>(value);
  const [availableOptions] = useState(
    filterObjectByKeys(
      {
        90: "< 3 months",
        180: "< 6 months",
        365: "< 1 year",
        730: "< 2 years",
      },
      filterSettings?.programDuration
    )
  );

  const debounceSetValue = useMemo(
    () => debounce((localValue: number | null) => setValue(localValue), 500),
    [setValue]
  );

  return (
    <EnumSingleSelectChipFilter
      label="Program duration"
      value={localValue?.toString()}
      id="program-duration-days"
      setValue={(value) => {
        const newValue = value ? parseInt(value, 10) : null;
        setLocalValue(newValue);
        debounceSetValue(newValue);
      }}
      enumToFriendlyMap={availableOptions}
    />
  );
};
